import { IDropdownItem } from '../../UI/Components/Dropdown/Dropdown';
import Utils from '../Utils';

// eslint-disable-next-line max-len

export const nationalitiesDescription = {
    1: 'Abkhaz,Abkhazian',
    2: 'Afghan',
    3: 'Albanian',
    4: 'Algerian',
    5: 'American Samoan',
    6: 'American,U.S',
    7: 'Andorran',
    8: 'Angolan',
    9: 'Anguillan',
    10: 'Antiguan,Barbudan',
    11: 'Argentine,Argentinean,Argentinian',
    12: 'Armenian',
    13: 'Aruban',
    14: 'Australian',
    15: 'Austrian',
    16: 'Azerbaijani',
    17: 'Bahamian',
    18: 'Bahraini',
    19: 'Bangladeshi',
    20: 'Barbadian',
    21: 'Basotho',
    22: 'Belarusian',
    23: 'Belgian',
    24: 'Belizean',
    25: 'Beninese,Beninois',
    26: 'Bermudian,Bermudan',
    27: 'Bhutanese',
    28: 'Bolivian',
    29: 'Bosnian',
    30: 'Brazilian',
    31: 'British',
    32: 'British Virgin Island',
    33: 'Bruneian',
    34: 'Bulgarian',
    35: 'Burkinabè,Burkinabé',
    36: 'Burmese',
    37: 'Burundian',
    38: 'Cambodian',
    39: 'Cameroonian',
    40: 'Canadian',
    41: 'Cape Verdean',
    42: 'Caymanian',
    43: 'Central African',
    44: 'Chadian',
    45: 'Chilean',
    46: 'Chinese',
    47: 'Christmas Island',
    48: 'Cocos Island',
    49: 'Colombian',
    50: 'Comorian',
    237: 'Congo BZ',
    52: 'Congolese',
    53: 'Cook Island,Cook Islands',
    54: 'Costa Rican',
    55: 'Croatian',
    56: 'Cuban',
    57: 'Cypriot',
    58: 'Czech',
    59: 'Danish',
    60: 'Djiboutian',
    61: 'Dominicand',
    62: 'Dominicane',
    63: 'Dutch',
    64: 'Ecuadorian',
    65: 'Egyptian',
    66: 'Emirati,Emirian',
    67: 'English',
    68: 'Equatorial Guinean,Equatoguinean',
    69: 'Eritrean',
    70: 'Estonian',
    71: 'Ethiopian',
    72: 'Falkland Island',
    73: 'Faroese',
    74: 'Fijian',
    75: 'Finnish',
    76: 'French',
    77: 'French Guianese',
    78: 'French Polynesian',
    79: 'Gabonese',
    80: 'Gambian',
    81: 'Georgian',
    82: 'German',
    83: 'Ghanaian',
    84: 'Gibraltar',
    85: 'Greek,Greciang,Hellenic',
    86: 'Greenlandic',
    87: 'Grenadian',
    88: 'Guadeloupe',
    89: 'Guamanian',
    90: 'Guatemalan',
    91: 'Guinean',
    92: 'Guyanese',
    93: 'Haitian',
    94: 'Honduran',
    95: 'Hong Kong,Hongkongese',
    96: 'Hungarian,Magyar',
    97: 'I-Kiribati',
    98: 'Icelandic',
    99: 'Indian',
    100: 'Indonesian',
    101: 'Iranian',
    102: 'Iraqi',
    103: 'Irish',
    104: 'Southern Irish',
    105: 'Israeli',
    106: 'Italian',
    107: 'Ivorian',
    108: 'Jamaican',
    109: 'Japanese',
    110: 'Jordanian',
    111: 'Kazakh,Kazakhstani',
    112: 'Kenyan',
    113: 'Kittitian,Nevisian',
    114: 'Kosovar,Kosovan',
    115: 'Kuwaiti',
    116: 'Kyrgyzstani,Kyrgyz,Kirgiz,Kirghiz',
    117: 'Laotian',
    118: 'Latvian',
    119: 'Lebanese',
    120: 'Liberian',
    121: 'Libyan',
    122: 'Liechtenstein',
    123: 'Lithuanian',
    124: 'Luxembourg,Luxembourgish',
    125: 'Macanese,Chinese',
    126: 'Macedonian',
    127: 'Mahoran',
    128: 'Malagasy',
    129: 'Malawian',
    130: 'Malaysian',
    131: 'Maldivian',
    132: 'Malian',
    133: 'Maltese',
    134: 'Manx',
    135: 'Marshallese',
    136: 'Martiniquais,Martinican',
    137: 'Mauritanian',
    138: 'Mauritian',
    139: 'Mexican',
    140: 'Micronesian',
    141: 'Moldovan',
    142: 'Mongolian',
    143: 'Monque,Monacan',
    144: 'Montenegrin',
    145: 'Montserratian',
    146: 'Moroccan',
    147: 'Motswana(pl.Batswana),Botswanan',
    148: 'Mozambican',
    149: 'Namibian',
    150: 'Nauruan',
    151: 'Nepalese,Nepali',
    152: 'New Caledonian',
    153: 'New Zealand',
    154: 'Ni-Vanuatu,Vanuatuan',
    155: 'Nicaraguan',
    156: 'Nigerian',
    157: 'Nigerien',
    158: 'Niuean',
    159: 'North Korean',
    160: 'Northern Irish,British,Irish',
    161: 'Northern Marianan',
    162: 'Norwegian',
    163: 'Omani',
    164: 'Pakistani',
    165: 'Palauan',
    166: 'Palestinian',
    167: 'Panamanian',
    168: 'Papua New Guinean,Papuan',
    169: 'Paraguayan',
    170: 'Peruvian',
    171: 'Philippine,Filipino',
    172: 'Pitcairn Island',
    173: 'Polish',
    174: 'Portuguese',
    175: 'Puerto Rican',
    176: 'Qatari',
    177: 'Romanian',
    178: 'Russian',
    179: 'Rwandan',
    180: 'Reunionese,Reunionnais',
    181: 'Sahraw,Sahrawian,Sahraouian',
    182: 'Saint-Pierrais,Miquelonnais',
    183: 'Salvadoran',
    184: 'Sammarinese',
    185: 'Samoan',
    186: 'Saudi,Saudi Arabian',
    187: 'Scots,Scottish,Scotch',
    188: 'Senegalese',
    189: 'Serbian',
    190: 'Seychellois',
    191: 'Sierra Leonean',
    192: 'Singaporean',
    193: 'Slovak',
    194: 'Slovenian,Slovene',
    195: 'Solomon Island',
    196: 'Somali,Somalian',
    197: 'South African',
    198: 'South Korean',
    199: 'South Ossetian',
    200: 'South Sudanese',
    201: 'Spanish',
    202: 'Sri Lankan',
    203: 'St. Helenian',
    204: 'St. Lucian',
    205: 'St. Vincentian,Vincentian',
    206: 'Sudanese',
    207: 'Surinamese',
    208: 'Swazi',
    209: 'Swedish',
    210: 'Swiss',
    211: 'Syrian',
    212: 'Szo Tomean',
    213: 'Taiwanese',
    214: 'Tajikistani',
    215: 'Tanzanian',
    216: 'Thai',
    217: 'Timorese',
    218: 'Togolese',
    219: 'Tongan',
    220: 'Trinidadian,Tobagonian',
    221: 'Tunisian',
    222: 'Turkish',
    223: 'Turkmen',
    224: 'Tuvaluan',
    225: 'Ugandan',
    226: 'Ukrainian',
    227: 'Uruguayan',
    228: 'Uzbekistani,Uzbek',
    229: 'Venezuelan',
    230: 'Vietnamese',
    231: 'Virgin Island',
    232: 'Wallisian,Futunan',
    233: 'Welsh',
    234: 'Yemeni',
    235: 'Zambian',
    236: 'Zimbabwean'
};

export const NATIONALITIES = Utils.sortArray(
    Object.entries(nationalitiesDescription).map(([id, description]) => ({
        id: Number(id),
        key: `citizen.${id}`,
        description: description.toUpperCase()
    })),
    'description'
);

const FALLBACK_NATIONALITY = {
    id: -1,
    key: 'generalInformation.fallbackCitizen',
    description: 'NATIONALITY'
};

const DEFAULT_NATIONALITY_KEY = 52;

const OTHERSDOCUMENT: IDropdownItem[] = [
    { id: 10, key: 'othersType.10', description: 'CIVIL SERVANT CARD' },
    { id: 2, key: 'othersType.2', description: 'MILITARY' },
    { id: 1, key: 'othersType.1', description: 'NATIONAL ID' },
    { id: 4, key: 'othersType.4', description: 'OFFICIAL CERTIFICATE ATTESTING THE LOSS OF ID' },
    { id: 7, key: 'othersType.7', description: 'POLICE' },
    { id: 6, key: 'othersType.6', description: 'REFUGEE CARD' },
    { id: 9, key: 'othersType.9', description: 'STUDENT CARD' },
    { id: 11, key: 'othersType.11', description: 'CHIEF OF VILLAGE ID LETTER' },
    { id: 3, key: 'othersType.3', description: 'DRIVING ID' }
];

const FALLBACK_OTHERSDOCUMENT: IDropdownItem = {
    id: -2,
    key: 'generalInformation.fallbackDocuments',
    description: 'IDENTITY'
};

const PROVINCES: IDropdownItem[] = [
    { id: 0, key: 'province.0', description: 'BAS UELE' },
    { id: 1, key: 'province.1', description: 'EQUATEUR' },
    { id: 2, key: 'province.2', description: 'HAUT KATANGA' },
    { id: 3, key: 'province.3', description: 'HAUT LOMAMI' },
    { id: 4, key: 'province.4', description: 'HAUT UELE' },
    { id: 5, key: 'province.5', description: 'ITURI' },
    { id: 6, key: 'province.6', description: 'KASAI' },
    { id: 7, key: 'province.7', description: 'KASAI CENTRAL' },
    { id: 8, key: 'province.8', description: 'KASAI ORIENTAL' },
    { id: 9, key: 'province.9', description: 'KINSHASA' },
    { id: 10, key: 'province.10', description: 'KONGO-CENTRAL' },
    { id: 11, key: 'province.11', description: 'KWANGO' },
    { id: 12, key: 'province.12', description: 'KWILU' },
    { id: 13, key: 'province.13', description: 'LOMAMI' },
    { id: 14, key: 'province.14', description: 'LUALABA' },
    { id: 15, key: 'province.15', description: 'MAI NDOMBE' },
    { id: 16, key: 'province.16', description: 'MANIEMA' },
    { id: 17, key: 'province.17', description: 'MONGALA' },
    { id: 18, key: 'province.18', description: 'NORD KIVU' },
    { id: 19, key: 'province.19', description: 'NORD UBANGI' },
    { id: 20, key: 'province.20', description: 'SANKURU' },
    { id: 21, key: 'province.21', description: 'SUD KIVU' },
    { id: 22, key: 'province.22', description: 'SUD UBANGI' },
    { id: 23, key: 'province.23', description: 'TANGANYIKA' },
    { id: 24, key: 'province.24', description: 'TSHOPO' },
    { id: 25, key: 'province.25', description: 'TSHUAPA' }
];

const FALLBACK_PROVINCE: IDropdownItem = {
    id: -2,
    key: 'generalInformation.fallbackProvince',
    description: 'PROVINCE'
};

const FALLBACK_CARD_ISSUED_PLACE: IDropdownItem = {
    id: -1,
    key: 'generalInformation.fallbackCardIssuedPlace',
    description: ''
};

const townsDescription = [
    { description: 'AKETI', provinceID: 0, id: 0 },
    { description: 'ARU', provinceID: 5, id: 1 },
    { description: 'BAKWA-KALONJI (LUKALABA)', provinceID: 8, id: 2 },
    { description: 'BALAMBA (KASUMBALESA)', provinceID: 2, id: 3 },
    { description: 'BANDUNDU', provinceID: 12, id: 4 },
    { description: 'BASANKUSU', provinceID: 1, id: 5 },
    { description: 'BASOKO (INCL. BANDU)', provinceID: 24, id: 6 },
    { description: 'BENI', provinceID: 18, id: 7 },
    { description: 'BINGA', provinceID: 17, id: 8 },
    { description: 'BOENDE', provinceID: 25, id: 9 },
    { description: 'BOLOBO', provinceID: 15, id: 10 },
    { description: 'BOMA', provinceID: 10, id: 11 },
    { description: 'BUKAMA (INCL. KIBANDA)', provinceID: 3, id: 12 },
    { description: 'BUKAVU', provinceID: 21, id: 13 },
    { description: 'BULUNGU', provinceID: 12, id: 14 },
    { description: 'BUMBA', provinceID: 17, id: 15 },
    { description: 'BUNIA', provinceID: 5, id: 16 },
    { description: 'BUSINGA', provinceID: 19, id: 17 },
    { description: 'BUTA', provinceID: 0, id: 18 },
    { description: 'BUTEMBO', provinceID: 18, id: 19 },
    { description: 'DIYABA-LUBUE', provinceID: 12, id: 20 },
    { description: 'DJUGU', provinceID: 5, id: 21 },
    { description: 'DUNGU', provinceID: 4, id: 22 },
    { description: 'FUNGURUME', provinceID: 14, id: 23 },
    { description: 'GANDAJIKA', provinceID: 13, id: 24 },
    { description: 'GBADOLITE', provinceID: 19, id: 25 },
    { description: 'GEMENA', provinceID: 22, id: 26 },
    { description: 'GOMA', provinceID: 18, id: 27 },
    { description: 'IDIOFA', provinceID: 12, id: 28 },
    { description: 'ILEBO', provinceID: 6, id: 29 },
    { description: 'INKISI (KISANTU)', provinceID: 10, id: 30 },
    { description: 'INONGO', provinceID: 15, id: 31 },
    { description: 'ISIRO', provinceID: 4, id: 32 },
    { description: 'KABALO', provinceID: 23, id: 33 },
    { description: 'KABINDA', provinceID: 13, id: 34 },
    { description: 'KALEMIE', provinceID: 23, id: 35 },
    { description: 'KALIMA', provinceID: 16, id: 36 },
    { description: 'KAMBOVE', provinceID: 2, id: 37 },
    { description: 'KAMINA', provinceID: 3, id: 38 },
    { description: 'KANANGA', provinceID: 7, id: 39 },
    { description: 'KANIAMA', provinceID: 3, id: 40 },
    { description: 'KANYABAYONGA', provinceID: 18, id: 41 },
    { description: 'KASANGULU', provinceID: 10, id: 42 },
    { description: 'KASONGO', provinceID: 16, id: 43 },
    { description: 'KATANDA', provinceID: 8, id: 44 },
    { description: 'KATWA', provinceID: 18, id: 45 },
    { description: 'KAYNA', provinceID: 18, id: 46 },
    { description: 'KENANKUNA (KABEYA)', provinceID: 8, id: 47 },
    { description: 'KENGE', provinceID: 11, id: 48 },
    { description: 'KIKWIT', provinceID: 12, id: 49 },
    { description: 'KIMPESE', provinceID: 10, id: 50 },
    { description: 'KINDU', provinceID: 16, id: 51 },
    { description: 'KINSHASA', provinceID: 9, id: 52 },
    { description: 'KIPAMBA (INCL. KIKONDJA)', provinceID: 3, id: 53 },
    { description: 'KIPUSHI', provinceID: 2, id: 54 },
    { description: 'KIRUMBA', provinceID: 18, id: 55 },
    { description: 'KISANGANI', provinceID: 24, id: 56 },
    { description: 'KITUKU', provinceID: 23, id: 57 },
    { description: 'KOLWEZI', provinceID: 14, id: 58 },
    { description: 'KONGOLO', provinceID: 23, id: 59 },
    { description: 'KUTU', provinceID: 15, id: 60 },
    { description: 'LIBENGE', provinceID: 22, id: 61 },
    { description: 'LIKASI', provinceID: 2, id: 62 },
    { description: 'LISALA', provinceID: 17, id: 63 },
    { description: 'LODJA', provinceID: 20, id: 64 },
    { description: 'LUBAO', provinceID: 13, id: 65 },
    { description: 'LUBERO', provinceID: 18, id: 66 },
    { description: 'LUBUMBASHI', provinceID: 2, id: 67 },
    { description: 'LUEBO', provinceID: 6, id: 68 },
    { description: 'LUKULA', provinceID: 10, id: 69 },
    { description: 'LUPUTA', provinceID: 13, id: 70 },
    { description: 'LUSAMBO', provinceID: 20, id: 71 },
    { description: 'MALEMBA-NKULU', provinceID: 3, id: 72 },
    { description: 'MANGAI', provinceID: 12, id: 73 },
    { description: 'MANGINA (MATANGO)', provinceID: 18, id: 74 },
    { description: 'MANONO', provinceID: 23, id: 75 },
    { description: 'MASI-MANIMBA', provinceID: 12, id: 76 },
    { description: 'MATADI', provinceID: 10, id: 77 },
    { description: 'MBANDAKA', provinceID: 1, id: 78 },
    { description: 'MBANZA-NGUNGU', provinceID: 10, id: 79 },
    { description: 'MBUJI MAYI', provinceID: 8, id: 80 },
    { description: 'MIABI', provinceID: 8, id: 81 },
    { description: 'MOANDA', provinceID: 10, id: 82 },
    { description: 'MOBA', provinceID: 23, id: 83 },
    { description: 'MOKAMBO', provinceID: 2, id: 84 },
    { description: 'MONGBWALU', provinceID: 5, id: 85 },
    { description: 'MULONGO', provinceID: 3, id: 86 },
    { description: 'MUSHIE', provinceID: 15, id: 87 },
    { description: 'MWEKA', provinceID: 6, id: 88 },
    { description: 'MWENE-DITU', provinceID: 13, id: 89 },
    { description: 'NIOKI', provinceID: 15, id: 90 },
    { description: 'NYUNZU', provinceID: 23, id: 91 },
    { description: 'OICHA', provinceID: 18, id: 92 },
    { description: 'PWETO', provinceID: 2, id: 93 },
    { description: 'RUTSHURU', provinceID: 18, id: 94 },
    { description: 'TSHELA', provinceID: 10, id: 95 },
    { description: 'TSHIKAPA', provinceID: 6, id: 96 },
    { description: 'TSHILENGE', provinceID: 8, id: 97 },
    { description: 'UVIRA', provinceID: 21, id: 98 },
    { description: 'WATSA', provinceID: 4, id: 99 },
    { description: 'YANGAMBI', provinceID: 24, id: 100 },
    { description: 'ZONGO', provinceID: 22, id: 101 }
];

export const OCCUPATIONS: IDropdownItem[] = [
    { id: 0, key: 'occupation.0', description: 'Artist/Liberal' },
    { id: 1, key: 'occupation.1', description: 'Athlète/Athlete' },
    { id: 2, key: 'occupation.2', description: 'Bettors/Casino gamblers' },
    { id: 3, key: 'occupation.3', description: 'Civil servant' },
    { id: 4, key: 'occupation.4', description: 'Comptable/Auditor' },
    { id: 5, key: 'occupation.5', description: 'Doctor/Nursing Staff' },
    { id: 6, key: 'occupation.6', description: 'Employee' },
    { id: 7, key: 'occupation.7', description: 'Jobless' },
    { id: 8, key: 'occupation.8', description: 'Lawyer/Judicial Staff/Notaries' },
    { id: 9, key: 'occupation.9', description: 'Merchant' },
    { id: 10, key: 'occupation.10', description: 'Personnel minier/Mining staff' },
    { id: 11, key: 'occupation.11', description: 'Police/Military' },
    { id: 12, key: 'occupation.12', description: 'Politician/Officials' },
    { id: 13, key: 'occupation.13', description: 'Real Estate Agent' },
    { id: 14, key: 'occupation.14', description: 'Religious staff' },
    { id: 15, key: 'occupation.15', description: 'Student/Pupil' }
];

const idCardIssuingPlace: IDropdownItem[] = [
    { id: 0, key: 'idCardIssuingPlace.0', description: 'BAS UELE' },
    { id: 1, key: 'idCardIssuingPlace.1', description: 'EQUATEUR' },
    { id: 2, key: 'idCardIssuingPlace.2', description: 'HAUT KATANGA' },
    { id: 3, key: 'idCardIssuingPlace.3', description: 'HAUT LOMAMI' },
    { id: 4, key: 'idCardIssuingPlace.4', description: 'HAUT UELE' },
    { id: 5, key: 'idCardIssuingPlace.5', description: 'ITURI' },
    { id: 6, key: 'idCardIssuingPlace.6', description: 'KASAI' },
    { id: 7, key: 'idCardIssuingPlace.7', description: 'KASAI CENTRAL' },
    { id: 8, key: 'idCardIssuingPlace.8', description: 'KASAI ORIENTAL' },
    { id: 9, key: 'idCardIssuingPlace.9', description: 'KINSHASA' },
    { id: 10, key: 'idCardIssuingPlace.10', description: 'KONGO-CENTRAL' },
    { id: 11, key: 'idCardIssuingPlace.11', description: 'KWANGO' },
    { id: 12, key: 'idCardIssuingPlace.12', description: 'KWILU' },
    { id: 13, key: 'idCardIssuingPlace.13', description: 'LOMAMI' },
    { id: 14, key: 'idCardIssuingPlace.14', description: 'LUALABA' },
    { id: 15, key: 'idCardIssuingPlace.15', description: 'MAI NDOMBE' },
    { id: 16, key: 'idCardIssuingPlace.16', description: 'MANIEMA' },
    { id: 17, key: 'idCardIssuingPlace.17', description: 'MONGALA' },
    { id: 18, key: 'idCardIssuingPlace.18', description: 'NORD KIVU' },
    { id: 19, key: 'idCardIssuingPlace.19', description: 'NORD UBANGI' },
    { id: 20, key: 'idCardIssuingPlace.20', description: 'SANKURU' },
    { id: 21, key: 'idCardIssuingPlace.21', description: 'SUD KIVU' },
    { id: 22, key: 'idCardIssuingPlace.22', description: 'SUD UBANGI' },
    { id: 23, key: 'idCardIssuingPlace.23', description: 'TANGANYIKA' },
    { id: 24, key: 'idCardIssuingPlace.24', description: 'TSHOPO' },
    { id: 25, key: 'idCardIssuingPlace.25', description: 'TSHUAPA' }
];

const FALLBACK_OCCUPATION: IDropdownItem = {
    id: -2,
    key: 'generalInformation.fallbackOccupation',
    description: 'OCCUPATIONS'
};

export interface ITown extends IDropdownItem{
    provinceID: number;
}

const TOWNS: ITown[] = townsDescription.map((town) => ({
    id: town.id,
    key: `town.${town.id}`,
    description: town.description,
    provinceID: town.provinceID
}));

const FALLBACK_TOWN = {
    id: -3,
    key: 'generalInformation.fallbackTown',
    description: 'TOWN',
    provinceID: -1
};

export default {
    NATIONALITIES,
    FALLBACK_NATIONALITY,
    DEFAULT_NATIONALITY_KEY,
    PROVINCES,
    FALLBACK_PROVINCE,
    FALLBACK_CARD_ISSUED_PLACE,
    TOWNS,
    FALLBACK_TOWN,
    OTHERSDOCUMENT,
    FALLBACK_OTHERSDOCUMENT,
    OCCUPATIONS,
    FALLBACK_OCCUPATION,
    idCardIssuingPlace
};
